const getThemePropsDefault = () => ({
  typography: {
    useNextVariants: true,
  },
});

export default getThemePropsDefault;
